import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import pe from "@/i18n/pe.json";
import Escudo from "@/components/site/Escudo";
import PeruRibbon from "@/components/site/PeruRibbon";

// Thank you page — Spanish only, per specification.
export default function ThankYouPage() {
  useEffect(() => {
    document.title = pe.thank_you.title + " | " + pe.brand.name;
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="thank-you-page">
      <PeruRibbon height={4} />
      <header className="bg-white border-b border-[#0E2A47]/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 h-20 flex items-center gap-3">
          <Escudo size={40} title={pe.header.escudo_alt} />
          <div className="flex flex-col leading-tight">
            <span className="font-serif text-[22px] tracking-tight text-[#0E2A47]">
              {pe.brand.name}
            </span>
            <span className="text-[11px] uppercase tracking-[0.16em] text-[#0E2A47]/60 hidden md:block">
              {pe.brand.tagline}
            </span>
          </div>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="max-w-2xl w-full text-center">
          <div className="mx-auto w-20 h-20 rounded-full bg-[#0F5F3F]/10 flex items-center justify-center">
            <CheckCircle2 className="w-12 h-12 text-[#0F5F3F]" aria-hidden="true" />
          </div>
          <h1
            className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0E2A47] leading-tight"
            data-testid="thank-you-title"
          >
            {pe.thank_you.title}
          </h1>
          <p className="mt-5 text-lg text-[#0E2A47]/85" data-testid="thank-you-subtitle">
            {pe.thank_you.subtitle}
          </p>
          <p className="mt-4 text-base text-[#0E2A47]/70 leading-relaxed">{pe.thank_you.body}</p>
          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 rounded-full bg-[#0F5F3F] text-white font-medium text-sm hover:bg-[#0a4c32]"
              data-testid="thank-you-back-home"
            >
              {pe.thank_you.back_home}
            </Link>
          </div>
          <p className="mt-8 text-xs uppercase tracking-[0.22em] text-[#0E2A47]/45" data-testid="thank-you-reference">
            {pe.thank_you.reference}
          </p>
        </div>
      </main>
      <footer className="bg-[#0E2A47] text-white">
        <PeruRibbon height={4} />
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 text-xs text-white/70">
          {pe.footer.copyright}
        </div>
      </footer>
    </div>
  );
}
